import './style.css'

export const HeaderCheckboxColumn = ({ getToggleAllPageRowsSelectedProps }) => {

    return (
        <div>
            <input className="checkbox-column" type="checkbox" {...getToggleAllPageRowsSelectedProps?.()} />
        </div>
    )
}


export const CheckboxColumn = ({ row }) => {

    return (
        <div>
            <input className="checkbox-column" type="checkbox" {...row?.getToggleRowSelectedProps?.()} />
        </div>
    )
}
